<div class="bdpk-welcome-page">
  <div class="bdpk-welcome-page--left-side">
    <img src="assets/img/bdpk-common/logo.svg">
    <div class="bdpk-welcome-page--ais-title">
      Автоматизированная<br>информационная система
    </div>
    <div class="bdpk-welcome-page--title">
      Большие данные<br>Пермского края
    </div>
    <div class="bdpk-welcome-page--entry-button btn" (click)="onStartButtonClick()">
      Войти
    </div>
  </div>
</div>




